import React from "react";
import { toast } from "react-toastify";
import "./CompactReference.css";
export function compactReference(value?: string | null): string {
  return !value ? "—" : value.length > 20 ? `${value.slice(0, 4)}…${value.slice(-8)}` : value;
}
export default function CompactReference({ value }: { value?: string | null }) {
  if (!value) return <span>—</span>;
  return <button type="button" className="navo-reference" title={value} aria-label={`Copy reference ${value}`} onClick={async () => {
    try { await navigator.clipboard.writeText(value); toast.success("Reference copied"); }
    catch { toast.info(`Reference: ${value}`); }
  }}>{compactReference(value)}</button>;
}
